export const getUrlParamEncoded = (param) => {
  const match = window.location.href.match(new RegExp(`${param}=([^&]*)`));
  return match ? match[1] : null;
};